import React, { Component } from 'react'
import { connect } from 'react-redux'
import RoleCompany from './rolesCompany'
import RoleGroup from './roleGroup'
import { getRoles, addRole, removeRole } from '../action/userActions'
import { clearCos } from '../action/ewCompanyActions'
import { Form, Col, Button, Card } from 'react-bootstrap'
class UserRole extends Component {

    constructor(props) {
        super(props)
        this.RoleCos = []
        this.RoleGroups = []
    }

    componentDidMount() {
        if (this.props.selectedUser)
            this.props.dispatch(getRoles(this.props.selectedUser))
    }

    render() {
        console.log('roles', this.props.roles)
        return <Card>
            <Card.Header>
                <Card.Title>Roles</Card.Title>
                <Button hidden={this.props.idea || (this.props.serviceAccount && this.props.roles.length > 0)} onClick={() => {
                    this.props.dispatch(addRole('A'))
                }}>
                    Add Role
                </Button>
            </Card.Header>

            <Card.Body>
                {this.props.roles.map((r, i) => {
                    return <Form.Row key={r.securityContextValue} style={{ borderBottom: 'solid', margin: '10px' }}>

                        <Form.Group hidden={this.props.idea} as={Col} controlId="formGridCompany">
                            <Form.Label>Action</Form.Label>
                            <br />
                            <Button onClick={() => {
                                this.props.dispatch(removeRole(i))
                                this.props.dispatch(clearCos(i))
                            }}>
                                Delete
                            </Button>
                        </Form.Group>

                        {/*   <Form.Group as={Col} controlId="formGridCompany">
                            <Form.Label>Type</Form.Label>
                            < br />
                           <strong>{r.type == 'M' ? 'Default' : 'Alias'}</strong>
                        </Form.Group> */}

                        <Form.Group hidden={this.props.idea} as={Col} controlId="formGridCompany">
                            <Form.Label>Company</Form.Label>
                            <RoleCompany index={i} dbCo={this.props.idea ? 'IDEA' : r.securityContextValue} />
                        </Form.Group>

                        <Form.Group hidden={this.props.serviceAccount} as={Col} controlId="formGridCompany">
                            <Form.Label>Group</Form.Label>
                            <RoleGroup serviceAccount={this.props.serviceAccount} index={i} roles={this.RoleCos[i]} dbGroup={r.groupName} />
                        </Form.Group>
                    </Form.Row>
                })}
            </Card.Body>


        </Card>
    }
}

const mapStateToProps = state => (
    {
        selectedUser: state.acct.user.selectedUser,
        roles: state.acct.user.roles,
    });



export default connect(mapStateToProps)(UserRole)